(function ($) {
    var Popup = function (element, options) {
        this.options = options;
        this.$element = $(element);
    };

    Popup.prototype.show = function () {
        this.$element.addClass('show');
    };

    Popup.prototype.hide = function () {
        this.$element.removeClass('show');
    };


    Popup.DEFAULTS = {
        height: '250px'
    };

    $.fn.popup = function (option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('irep.modal');
            var options = $.extend({}, Popup.DEFAULTS, $this.data(), typeof option == 'object' && option)

            if (!data) {
                $this.data('irep.modal', data = new Popup(this, options));
            }

            if (typeof option == 'string') {
                data[option]();
            }
        })
    };
}(jQuery));